// extracted by mini-css-extract-plugin
export default {"r_l":"_9842ac3208 f13cb56e98","t":"_568995efb8"};